"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgeUrls = void 0;
Object.defineProperty(exports, "deCommonsTranslations", {
  enumerable: true,
  get: function () {
    return _de.default;
  }
});
exports.defaultLanguage = void 0;
Object.defineProperty(exports, "enCommonsTranslations", {
  enumerable: true,
  get: function () {
    return _en.default;
  }
});
Object.defineProperty(exports, "esCommonsTranslations", {
  enumerable: true,
  get: function () {
    return _es.default;
  }
});
Object.defineProperty(exports, "frCommonsTranslations", {
  enumerable: true,
  get: function () {
    return _fr.default;
  }
});
Object.defineProperty(exports, "i18nCommons", {
  enumerable: true,
  get: function () {
    return _i18next.default;
  }
});
exports.navigatorLanguage = exports.languages = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _appStoreDe = _interopRequireDefault(require("../assets/images/store-badges/app-store-de.svg"));
var _appStoreEn = _interopRequireDefault(require("../assets/images/store-badges/app-store-en.svg"));
var _appStoreEs = _interopRequireDefault(require("../assets/images/store-badges/app-store-es.svg"));
var _appStoreFr = _interopRequireDefault(require("../assets/images/store-badges/app-store-fr.svg"));
var _googlePlayDe = _interopRequireDefault(require("../assets/images/store-badges/google-play-de.png"));
var _googlePlayEn = _interopRequireDefault(require("../assets/images/store-badges/google-play-en.png"));
var _googlePlayEs = _interopRequireDefault(require("../assets/images/store-badges/google-play-es.png"));
var _googlePlayFr = _interopRequireDefault(require("../assets/images/store-badges/google-play-fr.png"));
var _languages = require("../components/icons/languages");
var _de = _interopRequireDefault(require("./de.json"));
var _en = _interopRequireDefault(require("./en.json"));
var _es = _interopRequireDefault(require("./es.json"));
var _fr = _interopRequireDefault(require("./fr.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const languages = exports.languages = {
  en: {
    key: 'en',
    icon: /*#__PURE__*/_react.default.createElement(_languages.EnglishIcon, null),
    label: 'English',
    translation: _en.default
  },
  fr: {
    key: 'fr',
    icon: /*#__PURE__*/_react.default.createElement(_languages.FrenchIcon, null),
    label: 'Français',
    translation: _fr.default
  },
  de: {
    key: 'de',
    icon: /*#__PURE__*/_react.default.createElement(_languages.GermanIcon, null),
    label: 'Deutsch',
    translation: _de.default
  },
  es: {
    key: 'es',
    icon: /*#__PURE__*/_react.default.createElement(_languages.SpanishIcon, null),
    label: 'Español',
    translation: _es.default
  }
};
let navigatorLanguage = exports.navigatorLanguage = void 0;
if (typeof window !== 'undefined') {
  if (/^en\b/.test(navigator.language)) exports.navigatorLanguage = navigatorLanguage = 'en';else if (/^fr\b/.test(navigator.language)) exports.navigatorLanguage = navigatorLanguage = 'fr';else if (/^de\b/.test(navigator.language)) exports.navigatorLanguage = navigatorLanguage = 'de';else if (/^es\b/.test(navigator.language)) exports.navigatorLanguage = navigatorLanguage = 'es';
}
const badgeUrls = exports.badgeUrls = {
  en: {
    android: _googlePlayEn.default,
    ios: _appStoreEn.default
  },
  fr: {
    android: _googlePlayFr.default,
    ios: _appStoreFr.default
  },
  de: {
    android: _googlePlayDe.default,
    ios: _appStoreDe.default
  },
  es: {
    android: _googlePlayEs.default,
    ios: _appStoreEs.default
  }
};
let defaultLanguage = exports.defaultLanguage = 'en';
try {
  if (typeof window !== 'undefined') exports.defaultLanguage = defaultLanguage = localStorage.getItem('language') || navigatorLanguage && languages[navigatorLanguage]?.key || 'en';
} catch {
  console.error('localStorage access is denied');
}
_i18next.default.use(_reactI18next.initReactI18next).init({
  resources: languages,
  lng: defaultLanguage,
  fallbackLng: 'en',
  debug: process.env.NODE_ENV === 'development',
  keySeparator: '.',
  interpolation: {
    escapeValue: false
  }
});